import React from "react";

export const Close = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em" height="1em" fill="currentColor"
    >
        <path
            d="m17.62 15.7-.03.09c-.16.5-.77.67-1.17.33l-.09-.09-4.19-4.19c-.03-.03-.05-.07-.09-.11-.05.04-.08.07-.11.1l-4.22 4.22c-.23.23-.5.31-.81.2a.72.72 0 0 1-.3-1.14c.03-.04.07-.07.11-.11l4.19-4.19c.03-.03.07-.05.13-.1-.06-.05-.1-.07-.13-.1C9.5 9.2 8.1 7.79 6.7 6.39c-.35-.35-.34-.86.05-1.13.11-.07.25-.1.37-.15h.09c.27.03.45.19.63.37 1.37 1.37 2.74 2.74 4.1 4.11.03.03.06.06.12.11.03-.04.05-.08.08-.11l4.1-4.1c.18-.18.36-.34.63-.38h.09c.13.05.27.09.39.17.16.1.23.27.28.45v.24c-.05.22-.2.38-.35.54-1.38 1.37-2.75 2.74-4.12 4.12-.03.03-.07.05-.12.08.07.06.1.08.13.11 1.38 1.38 2.75 2.75 4.13 4.12.15.15.29.31.34.53-.02.07-.02.15-.02.23z"
        />
    </svg>
)